import { getBookableJourneys } from '../api/bookableJourneyApi';
import { normalizeListPayload, extractJourneyPaginationMeta } from './cmsContentLoader';

import { isChannelClosed } from './bookingAvailability';

/** Shape for booking pickers — mirrors journey summary fields booking forms expect. */
export function normalizeBookableJourneySummary(row) {
	if (!row) return null;
	return {
		slug: row.slug,
		title: row.title,
		group_enabled: row.group_enabled !== false,
		private_enabled: row.private_enabled !== false,
		active: row.active !== false,
		vendor_total_price: row.vendor_total_price,
		currency_code: row.currency_code,
		duration_days: row.duration_days,
		origin: row.origin,
		destination: row.destination,
		min_group_size: row.min_group_size,
		max_group_size: row.max_group_size,
		price_type: row.price_type,
		priority: row.priority ?? 0,
		guided_journey_slug: row.guided_journey_slug,
		group_available_months: row.group_available_months_stored,
		private_available_months: row.private_available_months_stored,
		group_availability_mode: row.group_availability_mode,
		private_availability_mode: row.private_availability_mode,
		group_available_months_label: row.group_available_months_label,
		private_available_months_label: row.private_available_months_label,
		available_months: row.available_months,
		available_months_stored: row.available_months_stored,
		available_months_label: row.available_months_label,
		booking_defaults: {
			vendor_total_price: row.vendor_total_price,
			currency_code: row.currency_code,
			duration_days: row.duration_days,
			origin: row.origin,
			destination: row.destination,
			min_group_size: row.min_group_size,
			max_group_size: row.max_group_size,
			group_enabled: row.group_enabled !== false,
			private_enabled: row.private_enabled !== false,
			price_type: row.price_type,
			group_available_months: row.group_available_months_stored,
			private_available_months: row.private_available_months_stored,
			group_availability_mode: row.group_availability_mode,
			private_availability_mode: row.private_availability_mode,
			available_months: row.group_available_months_stored?.length
				? row.group_available_months_stored
				: (row.private_available_months_stored?.length ? row.private_available_months_stored : []),
		},
	};
}

export async function loadBookableJourneysPage(params = {}) {
	try {
		const res = await getBookableJourneys(params);
		const list = normalizeListPayload(res.data, 'bookable_journeys');
		const meta = extractJourneyPaginationMeta(res.data);
		return {
			journeys: list.map(normalizeBookableJourneySummary).filter(Boolean),
			meta,
		};
	} catch {
		return {
			journeys: [],
			meta: { total_count: 0, total_pages: 1, current_page: 1, per_page: params.per_page || 50 },
		};
	}
}

export function filterGroupBookableJourneys(journeys) {
	return (journeys || []).filter((j) => j.group_enabled !== false && !isChannelClosed(j, 'group'));
}

export function filterPrivateBookableJourneys(journeys) {
	return (journeys || []).filter((j) => j.private_enabled !== false && !isChannelClosed(j, 'private'));
}
